import { render, staticRenderFns } from "./ImageWrapper.vue?vue&type=template&id=645f75e3&scoped=true&"
import script from "./ImageWrapper.vue?vue&type=script&lang=ts&"
export * from "./ImageWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ImageWrapper.vue?vue&type=style&index=0&id=645f75e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f75e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VProgressCircular,VRow})
